export default __webpack_public_path__ + "static/media/truck-empty.7e80e1e3.svg";